import { useEffect, useState } from 'react';
import { useDelayRender } from 'remotion';
import { Font } from '../../MainPlayer/types/Font';
import { loadRemotionFont } from '@/libs/fonts';

export const useLoadRemotionFont = ({ font }: { font?: Font }) => {
  const [loadedFontLocation, setLoadedFontLocation] = useState<string | null>(null);
  const { delayRender, continueRender, cancelRender } = useDelayRender();

  useEffect(() => {
    if (!font) {
      return;
    }
    let active = true;
    let hasSettled = false;
    const handle = delayRender('Loading font...');
    loadRemotionFont(font)
      .then(() => {
        if (active) {
          setLoadedFontLocation(font.location);
          hasSettled = true;
          continueRender(handle);
        }
      })
      .catch((err: any) => {
        if (active) {
          hasSettled = true;
          cancelRender(err);
        }
      });
    return () => {
      active = false;
      if (!hasSettled) {
        continueRender(handle);
      }
    };
  }, [font?.location]);

  const isPending = font && loadedFontLocation !== font.location;

  return { isPending };
};
